import { boolean, type Infer, integer, literal, min, object, string } from "superstruct";

export const ListItemBlockSchema = object({
    id: string(),
    type: literal("listItem"),
    html: string(),
    ordered: boolean(),
    depth: min(integer(), 0),
});

export type ListItemBlock = Infer<typeof ListItemBlockSchema>;
